import { Map, MapBrowserEvent } from 'ol';
import { Fragment, useEffect } from 'react';
import { CONTENT_TYPES } from '../../../constants/data.constants';
import {
    DeviceProperties,
    DeviceSetProperties,
    StackParams,
} from '../../../models/models';
import { getDevicesetTargeted } from '../../../utils/map/map.utils';

const MapInteractionsHandler = ({
    map,
    onDevicesetSelected,
}: {
    map: Map;
    onDevicesetSelected: (deviceset: StackParams) => void;
}) => {
    useEffect(() => {
        const handlePointerMove = (evt: MapBrowserEvent<UIEvent>) => {
            const devicesetFound = getDevicesetTargeted(map, evt);
            if (devicesetFound) {
                map.getTargetElement().style.cursor = 'pointer';
            } else {
                map.getTargetElement().style.cursor = '';
            }
        };

        const handleClick = (event: MapBrowserEvent<UIEvent>) => {
            const devicesetFound = getDevicesetTargeted(map, event);
            if (devicesetFound) {
                const properties = devicesetFound.getProperties() as
                    | DeviceSetProperties
                    | DeviceProperties;
                const deviceset = {
                    id: devicesetFound.getId() as string,
                    content_type: properties.content_type as CONTENT_TYPES,
                    name: properties.name,
                };
                onDevicesetSelected(deviceset);
            }
        };
        map.on('pointermove', handlePointerMove);
        map.on('click', handleClick);
        return () => {
            map.un('pointermove', handlePointerMove);
            map.un('click', handleClick);
        };
    }, [map, onDevicesetSelected]);

    return <Fragment />;
};

export default MapInteractionsHandler;
